/* Polsk katalog for locale-invoice-list-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'listControl.dialog': 'Zamknij otwarte okno dialogowe, zanim czat będzie kontynuował pracę z listą faktur.',
  'live.set_document_type': 'Wybieranie typu dokumentu …',
  'listControl.alreadyDone': 'Ta czynność została już wykonana dla tego dokumentu w ramach tego żądania.',
  'listControl.choice.attachment': 'Załącznik PDF',
  'listControl.choice.link': 'Link',
  'listControl.choice.reminder': 'Przypomnienie o płatności',
  'listControl.choice.purring': 'Monit',
  'listControl.working': 'Praca z listą faktur …',
  'listControl.unavailable': 'Lista faktur nie jest gotowa. Otwórz stronę i spróbuj ponownie.',
  'listControl.selection': 'Wybierz jednoznaczne dokumenty z wyników wyszukiwania, maksymalnie 20 naraz.',
  'listControl.changed': 'Lista lub wybór uległy zmianie. Wyszukaj i wybierz dokumenty ponownie.',
  'listControl.invalid': 'Czynności brakuje prawidłowych szczegółów.',
  'listControl.ineligible': 'Ta czynność nie pasuje do wszystkich wybranych dokumentów.',
  'listControl.reason': 'Podaj przyczynę wystawienia faktury korygującej.',
  'listControl.reminder': 'Wybierz nieopłaconą fakturę, rodzaj przypomnienia i nowy termin płatności. Wysyłka jest bez opłaty.',
  'listControl.payment': 'Podaj dla jednej faktury kwotę w granicach pozostałej należności, datę płatności i konto płatności.',
  'listControl.conversion': 'Wybierz gotową ofertę bez wcześniejszych konwersji. Użyj opcji Utwórz na stronie, jeśli potrzebujesz dodatkowej konwersji.',
  'listControl.uncertain': 'Wynik nie jest potwierdzony. Sprawdź dokument przed ponowną próbą; czat nie ponawia automatycznie.',
  'listControl.unsaved': 'Zapisz lub zamknij otwarty szkic przed zmianą dokumentu.',
  'listControl.stopped': 'Pozostała część wyboru nie została wykonana.',
  'listControl.done.searched': 'Wyszukiwanie jest widoczne na liście faktur.',
  'listControl.done.selected': 'Dokumenty są zaznaczone na liście.',
  'listControl.done.opened': 'Dokument jest otwarty.',
  'listControl.done.unsaved': 'Szkic jest otwarty i nie został jeszcze zapisany.',
  'listControl.done.prepared': 'Czynność i szczegóły są widoczne poniżej.',
  'listControl.done.sent': 'Wysłano.',
  'listControl.done.paid': 'Płatność została zarejestrowana.',
  'listControl.done.deleted': 'Szkic został usunięty.',
  'listControl.done.archived': 'Zarchiwizowano.',
  'listControl.done.restored': 'Przywrócono z archiwum.',
  'listControl.done.creditDraft': 'Faktura korygująca została zapisana jako szkic.',
  'listControl.done.issued': 'Dokument został utworzony.',
  'listControl.operation.send': 'Wyślij dokumenty',
  'listControl.operation.reminder': 'Wyślij przypomnienie / monit bez opłaty',
  'listControl.operation.credit': 'Wystaw korektę',
  'listControl.operation.archive': 'Archiwizuj',
  'listControl.operation.restore': 'Przywróć z archiwum',
  'listControl.operation.delete_draft': 'Usuń szkic',
  'listControl.operation.register_payment': 'Zarejestruj płatność',
  'listControl.operation.issue_draft': 'Utwórz dokument',
  'listControl.option.recipientEmail': 'Odbiorca',
  'listControl.option.deliveryMode': 'Sposób dostarczenia',
  'listControl.option.variant': 'Typ',
  'listControl.option.dueDate': 'Termin płatności',
  'listControl.option.comment': 'Komentarz',
  'listControl.option.creditReason': 'Przyczyna',
  'listControl.option.issue': 'Wystaw gotową fakturę korygującą',
  'listControl.option.amount': 'Kwota',
  'listControl.option.date': 'Data płatności',
  'listControl.option.settlementAccountCode': 'Konto płatności',
  'listControl.option.note': 'Notatka',
  'live.done.set_document_type': 'Wybrano typ dokumentu.',
});
